import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';

import Icon from '../components/Icon';

const DragHandle = SortableHandle(() => <Icon id="drag_handle"/>);
// const DragHandle = SortableHandle(() => <span id="drag_handle">Handle</span>);

const items = [];
for (let i = 0; i < 500; i++) {
  items.push(`item-${i}`);
}

const Item = SortableElement(({ item }) => {
  return (
    <li>
      <span>{item} </span>
      <DragHandle />
    </li>
  )
})

const renderItem = (item, index) => <Item key={item} index={index} item={item} />;

const List = SortableContainer(() => {
  return (
    <ul>
      {items.map(renderItem)}
    </ul>
  );
})


const handleSortEnd = ({ oldIndex, newIndex }) => {
  console.log('handleSortEnd', oldIndex, newIndex);
}

const ListContainer = () => {
  return (
    <List
      transitionDuration={300}
      useWindowAsScrollContainer={false}
      useDragHandle={true}
      onSortStart={() => console.log('onSortStart()')}
      onSortEnd={handleSortEnd}
    />
  );
}

export default ListContainer;



/** WEBPACK FOOTER **
 ** ./src/misc/dragDrop.js
 **/